import update from 'immutability-helper';
import {DELETED, SET, ADDED, UPDATED} from './actions';

const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.filters;

    case DELETED:
      return update(state, {
        $unset: [action.filter.id]
      });

    case ADDED:
      return {
        ...state,
        [action.filter.id]: action.filter
      };

    case UPDATED:
      return update(state, {
        [action.filter.id]: {
          $set: action.filter
        }
      });

    default:
      return state;
  }
};